import { render } from "./InfoBox.vue?vue&type=template&id=41aefd78&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=41aefd78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aidan\\Documents\\Code\\spotify-vue\\hilow\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aefd78"]])

export default __exports__